export default __webpack_public_path__ + "static/media/fastSearchBanner.d7924692.jpg";